module.exports = __webpack_public_path__ + "static/media/cjkoh_img.bf260006.png";